import primaryButtonDisabled from '../../../../../common/algorithms/primary-button-disabled';

const custom = (params) => primaryButtonDisabled(params);

export default custom;
